import React, { useRef, useState, useEffect } from "react";
import "./LocofastInNews.scss";

import LocofastInNews01 from "../../../assets/images/denim/LocofastInNews_01.webp";
import LocofastInNews02 from "../../../assets/images/denim/LocofastInNews_02.webp";
import LocofastInNews03 from "../../../assets/images/denim/LocofastInNews_03.webp";

const NEWS_ITEMS = [
  {
    src: LocofastInNews01,
    newsLink:
      "https://www.techinasia.com/textile-supplychain-firm-weaves-15m-series-money",
    altText: "textile supply chain firm weaves $15m in series A money",
  },
  {
    src: LocofastInNews02,
    newsLink:
      "https://www.vccircle.com/bharatpe-s-suhail-sameer-stellaris-others-back-supply-chain-firm-locofast",
    altText:
      "BharatPe's Suhail Sameer, Stellaris, Others Back Supply Chain Firm Locofast",
  },
  {
    src: LocofastInNews03,
    newsLink:
      "https://inc42.com/buzz/supplytech-startup-locofast-bags-15-mn-to-invest-in-technology/",
    altText: "Supplytech Startup Locofast Bags $15 Mn To Invest In Technology",
  },
];

const LocofastInNews = () => {
  const scrollerRef = useRef(null);
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);
  const userInteracted = useRef(false);

  useEffect(() => {
    if (paused || userInteracted.current) return;

    const interval = setInterval(() => {
      const next = (current + 1) % NEWS_ITEMS.length;
      scrollToItem(next);
    }, 5000);

    return () => clearInterval(interval);
  }, [current, paused]);

  const scrollToItem = (index) => {
    if (!scrollerRef.current) return;

    const card = scrollerRef.current.firstElementChild;
    if (!card) return;

    const gap = 24;
    const width = card.offsetWidth + gap;

    scrollerRef.current.scrollTo({
      left: index * width,
      behavior: "smooth",
    });

    setCurrent(index);
  };

  const handleScroll = () => {
    if (!scrollerRef.current) return;

    const card = scrollerRef.current.firstElementChild;
    if (!card) return;

    const gap = 24;
    const width = card.offsetWidth + gap;

    const index = Math.round(scrollerRef.current.scrollLeft / width);

    setCurrent(index);
  };

  return (
    <section className="locofast_in_news_section">
      <h1 className="heading locofastInNewsHeading">Locofast in News</h1>

      <div
        className="locofast_news_scroller"
        ref={scrollerRef}
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => !userInteracted.current && setPaused(false)}
        onTouchStart={() => {
          userInteracted.current = true;
          setPaused(true);
        }}
        onScroll={handleScroll}
      >
        {NEWS_ITEMS.map((item, index) => (
          <a
            key={index}
            className="locofast_news_item"
            href={item.newsLink}
            target="_blank"
          >
            <img src={item.src} alt={item.altText} />
          </a>
        ))}
      </div>

      <div className="hero_radioContainer locofast_radio_controller">
        {NEWS_ITEMS.map((_, index) => (
          <div
            key={index}
            className={`radioWrapper ${
              index === current ? "activeRadioWrapper" : ""
            }`}
            onClick={() => {
              userInteracted.current = true;
              setPaused(true);
              scrollToItem(index);
            }}
          >
            <input
              className={`herodot ${index === current ? "active" : ""}`}
              type="radio"
              name="locofast_news_slider"
              checked={index === current}
              readOnly
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default LocofastInNews;
